import React, { Fragment } from 'react';
import { Col } from 'react-bootstrap'
import Sidebar from './Sidebar'
import NavbarTop from './NavbarTop'

const SideNavTop = () => {
    return (
        <Fragment>
            <Col sm={12} id="navbar-top-wrapper">
              <NavbarTop/>
            </Col>
            <Col lg={2} md={2} sm={2} id="sidebar-wrapper" className="nopadding">
              <Sidebar/>
            </Col>
        </Fragment>
    );
};

export default SideNavTop;